<template>
  <form @submit.prevent class="add-trial-surgeon-form">
    <div class="content">
      <rp-select
        v-model="resource.trial_id"
        placeholder="Select Study"
        :isRequired="true"
        :error="trial_idError"
        @input="touch('trial_id')" >
        <option v-for="trial in trials" :key="trial.id" :value="trial.id">
          {{trial.name}}
        </option>
      </rp-select>
      <rp-textinput
        v-model="resource.enrolment_target"
        placeholder="Enrolment Target"
        :isRequired="true"
        :error="enrolment_targetError"
        @input="touch('enrolment_target')" />
    </div>
    <div class="buttons">
      <rp-button :disabled="isInvalid" type="primary" @click="submit">Submit</rp-button>
      <rp-button type="secondary" @click="cancel">Cancel</rp-button>
    </div>
  </form>
</template>

<script>
  import form from '../../../mixins/form'
  import TextInput from '../../../components/ui/inputs/TextInput'
  import Button from '../../../components/ui/inputs/Button'
  import Select from '../../../components/ui/inputs/StyledSelect'
  import {errorMessages} from '../../../api/error_messages'
  import {validationMixin} from 'vuelidate'
  import {required, numeric} from 'vuelidate/lib/validators'

  export default {
    mixins: [form, validationMixin],

    components: {
      'rp-textinput': TextInput,
      'rp-button': Button,
      'rp-select': Select,
    },

    props: {
      trials: Array,
    },

    computed: {
      ...errorMessages(['trial_id', 'enrolment_target']),

      payload() {
        return {
          trial_id: this.resource.trial_id,
          enrolment_target: this.resource.enrolment_target,
        }
      },
    },

    methods: {
      submit() {
        this.$emit('submit', this.payload)
      },

      cancel() {
        this.$emit('cancel')
      },
    },

    validations: {
      resource: {
        trial_id: {required},
        enrolment_target: {required, numeric}
      }
    },
  }
</script>

<style lang="sass" scoped>
  @import '../../../styles/base/variables'
  @import '../../../styles/helpers/mixins'
  @import '../../../styles/base/themes'

  .add-trial-surgeon-form
    width: 600px  
    padding: 20px
    border-radius: 20px    
    background: $color-panel-bg

    .content
      display: flex
      gap: 40px

    .buttons
      display: flex
      gap: 5px

</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/AddTrialSurgeon.vue